import { CheckoutCustomer } from "../CheckoutCustomer";
import { CheckoutOrderType } from "../CheckoutOrderType";
import { CheckoutTable } from "../CheckoutTable";
import styles from "./styles.module.scss";

export const CheckoutGroup = ({
  style,
  btnStyle,
  className = "",
  storeDetails = {},
}) => {
  return (
    <div
      className={`${styles.checkoutGroup} ${className}`}
      style={{ ...style }}
    >
      <CheckoutCustomer btnStyle={btnStyle} />
      {storeDetails?.allow_table ? <CheckoutTable btnStyle={btnStyle} /> : null}
      <CheckoutOrderType btnStyle={btnStyle} />
    </div>
  );
};
